'use strict';

import g from './utils/globalVariables.es6';

const TRIGGER_SELECTOR =
  'a[href*="#"]:not([href="#"]):not([data-toggle])';
const SCROLL_TIME_ANIMATION = 500;

const init = () => {
  g.$document
    .off('.goToHref')
    .on(
      'click.goToHref',
      TRIGGER_SELECTOR,
      click
    );
};

const click = event => {
  event.preventDefault();

  let $trigger = $(event.currentTarget);
  let targetSelector = $trigger.attr('href');

  goToTarget($(targetSelector), true);
};

const goToTarget = $target => {
  const MIN_TARGET_ELEMENTS = 0;

  if ($target.length > MIN_TARGET_ELEMENTS) {
    let targetPosistionTop = $target.offset().top;

    scrollToPosition(targetPosistionTop);
  }
};

const scrollToPosition = position => {
  $('html, body')
    .stop()
    .animate(
      { scrollTop: position },
      SCROLL_TIME_ANIMATION,
      'swing'
    );
};

export default init;
